export default __webpack_public_path__ + "static/media/SNOB.d32bfe23.png";